/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventmembershint2Inputs */

const en_eventmembershint2 = /** @type {(inputs: Eventmembershint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only active members of your organizer page see this event, in their feed and on your page. Nobody else can find or open it.`)
};

const de_eventmembershint2 = /** @type {(inputs: Eventmembershint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur aktive Mitglieder deiner Veranstalterseite sehen das Event, im Feed und auf deiner Seite. Alle anderen können es weder finden noch öffnen.`)
};

/**
* | output |
* | --- |
* | "Only active members of your organizer page see this event, in their feed and on your page. Nobody else can find or open it." |
*
* @param {Eventmembershint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventmembershint2 = /** @type {((inputs?: Eventmembershint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventmembershint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventmembershint2(inputs)
	return de_eventmembershint2(inputs)
});
export { eventmembershint2 as "eventMembersHint" }